module.exports = __webpack_public_path__ + "img/hthk.740ff74.png";